export const NAME = "name";
export const UPLOAD = "attachmentId";
